import type { PrivateEventFormFields as Fields } from './private-event-form-state';
import {
  END_AFTER_START_MESSAGE,
  errorsForStep,
  headcountError,
  type StepErrors,
} from './private-event-validation';

/** Create's "no past dates" rule compares against today; an empty today never
 *  matches, and editing may set any date. */
const PAST_DATES_ALLOWED = '';

/** The end is compared on full dates, so an event that runs past midnight is
 *  not mistaken for one that ends before it starts. */
function endsBeforeStart(f: Fields): boolean {
  if (!f.date || !f.startTime || !f.endTime) return false;
  const endDate = f.endDate || f.date;
  return `${endDate}T${f.endTime}` <= `${f.date}T${f.startTime}`;
}

export function whenWhatErrors(fields: Fields): StepErrors {
  const errs = errorsForStep(0, fields, PAST_DATES_ALLOWED);
  delete errs.endsAt;
  if (endsBeforeStart(fields)) errs.endsAt = END_AFTER_START_MESSAGE;
  const headcount = headcountError(fields.headcount);
  if (headcount) errs.headcount = headcount;
  return errs;
}
